import { Link } from "@tanstack/react-router";
import { Users } from "lucide-react";

import type { PersonDetail } from "@/api/db/people";

export function FichaSharedPhone({ person }: { person: PersonDetail }) {
	if (!person.shared_phone) {
		return null;
	}

	const others = person.phone_owners;

	return (
		<details className="surface-panel px-3 py-2 text-muted-foreground">
			<summary className="flex cursor-pointer list-none items-center gap-2 text-xs font-medium marker:hidden">
				<Users className="size-3.5" />
				{others.length === 0 && "Telefone compartilhado"}
				{others.length > 0 && `Telefone compartilhado por ${others.length + 1} pessoas`}
			</summary>

			{others.length > 0 && (
				<ul className="mt-2 flex flex-wrap gap-2 border-t border-border pt-2">
					{others.map((rel) => (
						<li key={rel.id}>
							<Link
								to="/pessoa/$id"
								params={{ id: rel.id }}
								className="inline-flex items-center rounded-md bg-secondary px-2 py-1 text-xs font-medium text-foreground transition-colors hover:bg-border/70 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
							>
								{rel.name}
							</Link>
						</li>
					))}
				</ul>
			)}
		</details>
	);
}
